import React, { type FunctionComponent } from 'react'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { placementLocationOptions } from 'domains/merchandising/constants/heroBanner.constants'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'
import { useSelectOptionsDashMessage } from 'domains/merchandising/utils/intl.hooks'
import { MerchandisingFormSelect } from 'domains/merchandising/components/form-input/MerchandisingFormSelect'

interface Props extends Omit<ControllerProps, 'name'> {}

export const HeroBannerFormLocation: FunctionComponent<Props> = ({ form }) => {
  const options = useSelectOptionsDashMessage(placementLocationOptions)

  return (
    <MerchandisingFormSection
      titleId="merchandising.hero-banners.section.location.title"
      tooltipId="merchandising.hero-banners.section.location.tooltip"
      renderAction
    >
      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormSelect
            identifier="platform"
            form={form}
            labelId="merchandising.hero-banners.section.location.title"
            options={options}
            isMulti
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
    </MerchandisingFormSection>
  )
}
